export default __webpack_public_path__ + "static/media/wrong_answer.413675a2.mp3";